import { makeStyles, Theme } from '@material-ui/core/styles';

const styles = makeStyles((theme: Theme) => ({
  closeIcon: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  dialogButton: {
    '& span': {
      textTransform: 'uppercase',
      fontWeight: 'bold',
    },
  },
  cancelButton: {
    backgroundColor: 'transparent',
  },
  confirmButton: {
    backgroundColor: '#141414',
    color: 'var(--light-primary-contrast, #FFF)',
    '&:hover': {
      background: '#141414',
    },
  },
}));

export default styles;
